// extracted by mini-css-extract-plugin
module.exports = {"favoritesContainer":"_2c56ab78","spacer":"_736646ae","loading":"_fd08809e"};